import { vSaveScroll } from './saveScroll'
import clickOutside from "@/directives/clickOutside.js"

const directives = {
  'save-scroll': vSaveScroll,
  'click-outside': clickOutside,
}

export default {
  install(app) {
    Object.entries(directives).forEach(([name, directive]) => {
      app.directive(name, directive)
    })
  }
}
